/**
 * Pretty-print X12 for display/diff.
 * New format: CR/LF line-delimited — keep newlines, do not insert `~`.
 * Old format: tilde-delimited with no newlines — split on `~` and join with `~\n`.
 */
export function formatX12ForDisplay(x12: string): string {
    if (/[\r\n]/.test(x12)) {
        return x12.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
    }

    return x12.split('~').join('~\n');
}
